// extracted by extract-css-chunks-webpack-plugin
module.exports = {"universalTextInput":"UniversalTextInput__universalTextInput___Q6bwS","universalTextInputSingleLine":"UniversalTextInput__universalTextInputSingleLine___1z2xU"};
    if(module.hot) {
      // 1778083492476
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  